import * as React from "react";

import {cs} from "@Common/react/chain-services";

import {AddressBookLayout} from "../common/address-book-layout";

import {MailingListsPanel} from "../../common/mailing-lists-panel/mailing-lists-panel";
import { consumeContext } from "@Common/react/context";

export const MailingRoute = ({}) => cs(
    consumeContext("session"),
    ({}, next) => AddressBookLayout({activeTab: "mailing", next}),
    ({session}) => MailingListsPanel({entityId: session.value.agentId}),
);
